import {
  AudioOutlined,
  AuditOutlined,
  BankOutlined,
  FireOutlined,
  MailOutlined,
  MessageOutlined,
  PhoneOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  ShoppingOutlined,
  TagsOutlined,
  ThunderboltOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import {ProductNavIcon, RecordIcon} from "../components/icons/icons";
import {IS_PUBLIC_PROFILE_BUILDER_ENABLED} from "./config";

interface IDashboardMenuItem {
  title?: string;
  navLink: {
    to: string;
    label: string;
    icon: React.ReactNode;
    isComingSoon?: boolean;
    isBtnLink?: boolean;
    children?: {
      to: string;
      label: string;
    }[];
  }[];
}

interface IDashboardMenuData extends Array<IDashboardMenuItem> {}

export const DashboardMenuData: IDashboardMenuData = [
  {
    navLink: [
      {
        to: "/home",
        label: "Home",
        icon: <FireOutlined />,
      },
      {
        to: "/calls",
        label: "1:1 Sessions",
        icon: <PhoneOutlined />,
        children: [
          {
            label: "Availability",
            to: "/calls/availability?activeTab=availability",
          },
          {
            label: "Unavailability",
            to: "/calls/availability?activeTab=unavailability",
          },
          {
            label: "Booking limits",
            to: "/calls/availability?activeTab=bookingLimits",
          },
        ],
      },

      {
        to: "/products",
        label: "Store",
        icon: <ProductNavIcon />,
      },
      {
        to: "/live-classes",
        label: "Live events",
        icon: <AudioOutlined />,
      },
      {
        to: "/discounts",
        label: "Discounts",
        icon: <TagsOutlined />,
      },

      {
        to: "/recordings",
        label: "Recordings",
        icon: <RecordIcon />,
      },
      {
        to: "/automations",
        label: "Automations",
        icon: <ThunderboltOutlined />,
      },
      {
        to: "/messages",
        label: "Messages",
        icon: <MessageOutlined />,
      },
      {
        to: "/customers",
        label: "Customers",
        icon: <UsergroupAddOutlined />,
      },
      {
        to: "/transactions",
        label: "Transactions",
        icon: <WalletOutlined />,
      },
      {
        to: "/reviews",
        label: "Reviews",
        icon: <AuditOutlined />,
      },
    ],
  },
  {
    title: "YOUR ACCOUNT",
    navLink: [
      {
        to: "/profile",
        label: "Profile",
        icon: <UserOutlined />,
      },
      ...(IS_PUBLIC_PROFILE_BUILDER_ENABLED
        ? [
            {
              to: "/public-profile",
              label: "Public profile",
              icon: <UserOutlined />,
            },
          ]
        : []),
      {
        to: "/payouts",
        label: "Payouts",
        icon: <BankOutlined />,
      },
      {
        to: "/settings",
        label: "Settings",
        icon: <SettingOutlined />,
      },
    ],
  },
  {
    title: "HELP AND SUPPORT",
    navLink: [
      {
        to: "https://coachli.notion.site/Helpdesk-4039d986b45e4236a5ee76a5e4de45a5",
        label: "FAQs",
        icon: <QuestionCircleOutlined />,
        isBtnLink: true,
      },
      {
        to: "mailto:hello@coachli.co",
        label: "Contact us",
        icon: <MailOutlined />,
        isBtnLink: true,
      },
    ],
  },
];

export const CustomerDashboardMenuData: IDashboardMenuData = [
  {
    navLink: [
      {
        to: "/customer/home",
        label: "Home",
        icon: <FireOutlined />,
      },
      {
        to: "/customer/calls",
        label: "1:1 Sessions",
        icon: <PhoneOutlined />,
      },
      {
        to: "/customer/live-classes",
        label: "Live events",
        icon: <AudioOutlined />,
      },
      {
        to: "/customer/products",
        label: "Store",
        icon: <ShoppingOutlined />,
      },
      {
        to: "/customer/messages",
        label: "Messages",
        icon: <MessageOutlined />,
      },
    ],
  },

  {
    title: "HELP AND SUPPORT",
    navLink: [
      {
        to: "https://coachli.notion.site/Helpdesk-4039d986b45e4236a5ee76a5e4de45a5",
        label: "FAQs",
        icon: <QuestionCircleOutlined />,
        isBtnLink: true,
      },
      {
        to: "mailto:hello@coachli.co",
        label: "Contact us",
        icon: <MailOutlined />,
        isBtnLink: true,
      },
    ],
  },
];
